import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import thunk from 'redux-thunk';
import storage from 'redux-persist/lib/storage';
import rootReducer from '../reducers/index';

// CE QUI SURVIT À LA FERMETURE DE L'ONGLET : la session, et rien d'autre.
//
// Le magasin entier partait dans le stockage local du navigateur — les vingt tranches,
// dont tout l'espace de travail (catalogue, fournisseurs, clients, projets, réglages de
// l'entreprise). Tout cela restait lisible, en clair, par n'importe quel script tournant sur
// la page et par quiconque ouvre les outils du navigateur sur un poste partagé. Et un
// espace de travail chargé avant un changement de compte y traînait encore.
//
// Le jeton vit dans la tranche `user`, à côté de l'espace de travail : on garde donc la
// tranche, mais on n'en écrit que les clés de session. Rien n'est perdu à l'écran : chaque
// page protégée revalide le jeton avant de s'afficher, et cette validation renvoie l'espace
// de travail entier ; les listes se chargent au montage de leur écran.
export const SESSION_KEYS = ['accessToken', 'client', 'uid', 'signedIn'];

const sessionOnly = (user) => SESSION_KEYS.reduce((kept, key) => (
  user && user[key] !== undefined ? { ...kept, [key]: user[key] } : kept
), {});

// À l'écriture, la tranche `user` est réduite à la session.
const keepSession = createTransform(sessionOnly, sessionOnly, { whitelist: ['user'] });

// À la lecture, même règle — et elle compte : un navigateur qui a connu la version d'avant
// garde une charge COMPLÈTE sous la même clé. Le réconciliateur par défaut la reprendrait
// telle quelle, vingt tranches comprises, jusqu'à la première écriture.
const sessionReconciler = (inbound, original, reduced) => ({
  ...reduced,
  user: { ...reduced.user, ...sessionOnly(inbound && inbound.user) },
});

export const persistConfig = {
  // ⚠️ Garder la clé « root » : la première écriture ÉCRASE l'ancienne charge complète.
  // En changer laisserait l'ancienne, avec tout l'espace de travail, orpheline dans le
  // navigateur.
  key: 'root',
  storage,
  whitelist: ['user'],
  transforms: [keepSession],
  stateReconciler: sessionReconciler,
};

const pReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(pReducer,
  compose(
    applyMiddleware(thunk),
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  ));

const persistor = persistStore(store);

export { persistor, store };
